import {
  anyValidator,
  validateAlpha,
  validateAlphaNumeric,
  validateCompanyRFC,
  validateDateLessOrEqualThanToday,
  validateNumeric,
  validatePhoneNumber,
  validatePropertyNumber,
  validateStreet,
  validateUrl,
  validateZipCode,
} from "../generalValidators.ts";

export const businessFormValidators = {
  business_legal_name: anyValidator,
  creation_date: validateDateLessOrEqualThanToday,
  public_instrument: anyValidator,
  notary: anyValidator,
  rfc_company: validateCompanyRFC,
  website: validateUrl,
  phone: validatePhoneNumber,
  employee_number: validateNumeric,
  business_sector: validateAlpha,
  office_number: validateNumeric,
  property_occupants: validateNumeric,
  street: validateStreet,
  exterior_number: validatePropertyNumber,
  interior_number: validatePropertyNumber,
  neighborhood: validateAlphaNumeric,
  postal_code: validateZipCode,
  municipality: validateAlpha,
  current_landlord: validateAlpha,
  current_landlord_phone: validatePhoneNumber,
  monthly_sales_expenses: validateNumeric,
  monthly_admin_expenses: validateNumeric,
  monthly_production_expenses: validateNumeric,
};
